import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const AdmissionsTab = ({ institution }) => {
  return (
    <div className="space-y-6">
      {/* Application Process */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Processus de candidature
        </h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div>
            <h4 className="font-medium text-foreground mb-3">Étapes de candidature</h4>
            <div className="space-y-3">
              {institution?.applicationProcess?.map((step, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-xs font-medium">
                    {index + 1}
                  </div>
                  <div>
                    <div className="font-medium text-foreground">{step?.title}</div>
                    <div className="text-sm text-muted-foreground">{step?.description}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div>
            <h4 className="font-medium text-foreground mb-3">Documents requis</h4>
            <div className="space-y-2">
              {institution?.requiredDocuments?.map((doc, index) => (
                <div key={index} className="flex items-center gap-2">
                  <Icon name="FileText" size={16} className="text-primary" />
                  <span className="text-sm text-muted-foreground">{doc}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Admission Thresholds */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Seuils d'admission des années précédentes
        </h3>
        <div className="h-64 mb-4" aria-label="Graphique des seuils d'admission">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={institution?.admissionThresholds}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="year" />
              <YAxis />
              <Tooltip 
                formatter={(value) => [`${value}/20`, 'Seuil']}
                labelFormatter={(label) => `Année ${label}`}
              />
              <Bar dataKey="threshold" fill="var(--color-primary)" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {institution?.admissionStats?.map((stat, index) => (
            <div key={index} className="text-center p-3 bg-muted rounded-lg">
              <div className="text-lg font-semibold text-primary">{stat?.value}</div>
              <div className="text-xs text-muted-foreground">{stat?.label}</div>
            </div>
          ))}
        </div>
      </div>
      {/* Important Dates */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Dates importantes
        </h3>
        <div className="space-y-4">
          {institution?.importantDates?.map((date, index) => (
            <div key={index} className="flex items-center gap-4 p-4 border border-border rounded-lg">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name="Calendar" size={20} className="text-primary" />
              </div>
              <div className="flex-1">
                <div className="font-medium text-foreground">{date?.event}</div>
                <div className="text-sm text-muted-foreground">{date?.description}</div>
              </div>
              <div className="text-right">
                <div className="font-medium text-foreground">{date?.date}</div>
                <div className="text-sm text-muted-foreground">{date?.time}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdmissionsTab;